import {
  setActiveSidebarTabId,
  setSidebarContent
} from 'features/sidebar/sidebarSlice';

import { useScrollToPageTopOnUpload } from 'hooks/useScrollToPageTopOnUpload';
import { useAppDispatch } from 'hooks/useTypedRedux';

import { scrollToTop } from 'utils/scrollToTop';

import { SidebarContentTypes } from 'constants/enums';

import ApplicationRejectModal from '../ApplicationRejectModal/ApplicationRejectModal';
import { APPLICATION_SIDEBAR_ITEMS_IDS } from '../ApplicationSidebar/ApplicationSidebar';

interface UseApplicationActionsProps {
  applicationId?: string;
  setActiveComponent: (component: JSX.Element | null) => void;
  isSplitView: boolean;
  onSplitViewOpen?: (applicationId: string) => void;
}

const useApplicationActions = ({
  applicationId,
  setActiveComponent,
  isSplitView,
  onSplitViewOpen
}: UseApplicationActionsProps): {
  sendOfferLetter: () => void;
  scheduleInterview: () => void;
  rejectApplication: () => void;
} => {
  const dispatch = useAppDispatch();

  const sendOfferLetter = () => {
    if (!applicationId) {
      return;
    }

    if (isSplitView) {
      onSplitViewOpen?.(applicationId);
      dispatch(setActiveSidebarTabId(APPLICATION_SIDEBAR_ITEMS_IDS.OFFER));
      scrollToTop();
      return;
    }

    dispatch(
      setSidebarContent({
        contentId: SidebarContentTypes.OfferView,
        activeUserId: applicationId
      })
    );
  };

  const scheduleInterview = () => {
    if (!applicationId) {
      return;
    }

    if (isSplitView) {
      onSplitViewOpen?.(applicationId);
      dispatch(setActiveSidebarTabId(APPLICATION_SIDEBAR_ITEMS_IDS.INTERVIEW));
      scrollToTop();
      return;
    }

    dispatch(
      setSidebarContent({
        contentId: SidebarContentTypes.InterviewView,
        activeUserId: applicationId
      })
    );
  };

  const handleCloseActiveComponent = () => {
    setActiveComponent(null);
  };

  const rejectApplicationActiveComponent = (
    <ApplicationRejectModal
      applicationId={applicationId}
      onClose={handleCloseActiveComponent}
    />
  );

  const rejectApplication = () => {
    setActiveComponent(rejectApplicationActiveComponent);
  };

  return { sendOfferLetter, scheduleInterview, rejectApplication };
};

export default useApplicationActions;
